import React from 'react'
import values from 'mout/object/values'
import sortByPropText from '../../../../helpers/content/manageSets/sortByPropText';
import pacingStyles from '../../../../helpers/assessment/pacingStyles'
import getHeat from '../../../../helpers/assessment/getHeat';

export default function PacingHeatMaps ({byItem, assessmentSubtests}) {
  const subtests = sortByPropText(values(assessmentSubtests), 'index')
  let heatMaps = []
  subtests.forEach((subtest, n) => {
    const subtestId = subtest.setId
    const items = sortByPropText(values(byItem[subtestId]), 'index')
    let heatMarkers = []
    items.forEach((item, m) => {
      let heat = getHeat(item.raw, item.possible)
      heatMarkers.push(
        <li 
          className={`heatMarker heat${heat}`} 
          key={`${subtest.displayName}${item.itemId}`}
        >
          {`Question ${m + 1}`}
        </li>
      )
      if (subtest.displayName === 'English') {
        if (m + 1 === 1 || (m + 1) % 25 === 0) {
          let left = '-6px'
          if (m + 1 === 25) {
            left = '66px'
          } else if (m + 1 === 50) {
            left = '141px'
          } else if (m + 1 === 75) {
            left = '216px'
          }
          heatMarkers.push(
            <span 
              className='questionMarker' 
              style={{left}}
              key={`qm${item.itemNumber}`}
            >
              {m + 1}
            </span>
          )
        }
      } else if (subtest.displayName === 'Math') {
        if (m + 1 === 1 || (m + 1) % 20 === 0) {
          let left = '-5px'
          if (m + 1 === 20) {
            left = '66px'
          } else if (m + 1 === 40) {
            left = '140px'
          } else if (m + 1 === 60) {
            left = '216px'
          }
          heatMarkers.push(
            <span 
              className='questionMarker' 
              style={{left}}
              key={`qm${item.itemNumber}`}
            >
              {m + 1}
            </span>
          )
        }
      } else if (subtest.displayName === 'Reading') {
        if (m + 1 === 1 || (m + 1) % 20 === 0) {
          let left = '-6px'
          if (m + 1 === 20) {
            left = '102px'
          } else if (m + 1 === 40) {
            left = '215px'
          }
          heatMarkers.push(
            <span 
              className='questionMarker' 
              style={{left}}
              key={`qm${item.itemNumber}`}
            >
              {m + 1}
            </span>
          )
        }
      } else if (subtest.displayName === 'Science') {
        if (m + 1 === 1 || (m + 1) % 20 === 0) {
          let left = '-5px'
          if (m + 1 === 20) {
            left = '102px'
          } else if (m + 1 === 40) {
            left = '215px'
          }
          heatMarkers.push(
            <span 
              className='questionMarker' 
              style={{left}}
              key={`qm${item.itemNumber}`}
            >
              {m + 1}
            </span>
          )
        }
      }
    })
    const nameLC = subtest.displayName.toLowerCase()
    const style = pacingStyles[nameLC]
    heatMaps.push(
      <div className={nameLC} style={style} key={`hm${nameLC}`}>
        <h3>{subtest.displayName}</h3>
        <ol className='heatMap'>
          {heatMarkers}
        </ol>
      </div>
    )
  })

  return (
    <div className='skill-graphs'>
      <div className='reports'>
        {heatMaps}
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/TestTaking/PacingHeatMaps.js